import { useRoutes } from "@app/hooks/useRoutes"
import { CustomLink } from "@components/Link"
import { memo, Fragment } from "react"
import { Box, HStack, Text, Image } from "@chakra-ui/react"

const TextWrapper = ({ title, fontSize = "xs", noLetterSpacing }: { title: string; fontSize: string; noLetterSpacing?: boolean }) => (
  <Text fontSize={fontSize} letterSpacing={noLetterSpacing ? "unset" : "0.15em"}>
    {title}
  </Text>
)

const Proposition = ({ icon, link: rawLink, title, showDivider = true, fontSize, noLetterSpacing = false }) => {
  const { urlResolver } = useRoutes()

  const hasLink = !!rawLink
  const link = urlResolver(rawLink)

  return (
    <Fragment>
      <HStack py={1.5}>
        {icon?.asset?.url && <Image src={icon?.asset?.url} w={3.5} />}
        {hasLink ? (
          <CustomLink to={link?.url}>
            <TextWrapper title={link?.title || title} fontSize={fontSize} />
          </CustomLink>
        ) : (
          <TextWrapper title={title} fontSize={fontSize} noLetterSpacing={noLetterSpacing} />
        )}
      </HStack>
      {showDivider && (
        <Box display={["none", "block"]} borderRight={["none", "1px"]} borderColor="brand.avocado" _last={{ border: "unset" }}>
          &nbsp;
        </Box>
      )}
    </Fragment>
  )
}

const MemoProposition = memo(Proposition)
export { MemoProposition as Proposition }
